import {
    UPDATE_PAYMENT_HISTORY,
    SET_HAS_POLLING_BEEN_REINSTATED,
} from '../actions/paymentHistory';

export const paymentHistoryReducer = (
    state = { hasPollingBeenReinstated: false },
    action,
) => {
    switch (action.type) {
        case UPDATE_PAYMENT_HISTORY:
            return {
                ...action.payload,
                hasPollingBeenReinstated: state.hasPollingBeenReinstated,
            };

        case SET_HAS_POLLING_BEEN_REINSTATED:
            return {
                ...state,
                hasPollingBeenReinstated: action.payload,
            };

        default:
            return state;
    }
};
